// @flow
const reactCCFormContainer = '#react-ccform';

export type AppProps = {
  onAddOrRemoveCard: () => void,
  recieveSetDisabledReactCCFormUIFunc: Function => void,
  serviceType: string,
  enableSubmit: () => void,
  disableSubmit: () => void,
};

/**
 * Mounts the CreditCardForm into a given (or default) DOM element and
 * returns an "unmount" teardown function that can be used to clean up
 * if needed.
 */
export const mount = (appProps: AppProps, id: string = reactCCFormContainer) => {
  let ReactDOM;
  let renderRootElement;
  let ConversationsCheckoutPageContainer;
  // bail if react is undefined, this helps us avoid loading react on the page when the experiment isn't running
  try {
    ReactDOM = require('react-dom');
    renderRootElement = require('../../../utils/renderRootElement').default;
    ConversationsCheckoutPageContainer = require('./ConversationsCheckoutPageContainer').default;
  } catch (e) {
    return () => {};
  }

  if (document.querySelector(id) && renderRootElement) {
    renderRootElement(ConversationsCheckoutPageContainer, id, appProps);
    if (module.hot) {
      module.hot.accept('./ConversationsCheckoutPageContainer', () => {
        renderRootElement(
          // eslint-disable-next-line global-require
          require('./ConversationsCheckoutPageContainer').default,
          id,
          appProps
        );
      });
    }
    return () => ReactDOM.unmountComponentAtNode(document.querySelector(id));
  }
  return () => {};
};



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/ConversationsCheckoutPage/index.js